import { IconProps } from './types';

export function Party({ size, ...props }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} fill="none" viewBox="0 0 25 24" {...props}>
      <path
        d="M4.3 9.80005L0.5 20.5L11.2 16.71M2.5 1.5H2.51M20.5 6.5H20.51M13.5 0.5H13.51M20.5 18.5H20.51M20.5 0.5L18.26 1.25C17.6224 1.46239 17.0783 1.88964 16.7208 2.45872C16.3633 3.02781 16.2146 3.70339 16.3 4.37C16.4 5.23 15.73 6 14.85 6H14.47C13.61 6 12.87 6.6 12.71 7.44L12.5 8.5M20.5 11.4999L19.68 11.1699C18.82 10.8299 17.86 11.3699 17.7 12.2799C17.59 12.9799 16.98 13.4999 16.27 13.4999H15.5M9.5 0.5L9.83 1.32C10.17 2.18 9.63 3.14 8.72 3.3C8.02 3.4 7.5 4.02 7.5 4.73V5.5M9.50002 11.5C11.43 13.43 12.33 15.67 11.5 16.5C10.67 17.33 8.43002 16.43 6.50002 14.5C4.57002 12.57 3.67002 10.33 4.50002 9.50002C5.33002 8.67002 7.57002 9.57002 9.50002 11.5Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
